import { createFileRoute, Link } from "@tanstack/react-router";
import { labelForOAuthError } from "@/lib/oauth";

export const Route = createFileRoute("/auth/oauth-error")({
  validateSearch: (search: Record<string, unknown>) => ({
    code: typeof search.code === "string" ? search.code : undefined,
  }),
  component: OAuthError,
});

function OAuthError() {
  const { code } = Route.useSearch();
  const label = labelForOAuthError(code);
  return (
    <main className="auth-banner">
      <p>{label}</p>
      <Link to="/login" search={{}}>
        BACK TO SIGN IN
      </Link>
    </main>
  );
}
